import * as d3 from "d3";
import { colonAnnotation,  numberFormat, responsivefy} from "@/common/functions";

export default function (chart, divId, vizName,resData, filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;

    console.log("Chart chart called:", chart);
    console.log("Chart divid called:", divId);
    console.log("Chart vizName called:", vizName);
    console.log("Chart filterparam called:", filterParam);
    console.log("kiran Agadi");

    // axios.post(url, filterParam).then(res => {
        let data = resData
        var maxMetricValue = d3.max(data, d => d.metric1);

        // append the svg object to the body of the page
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width - chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')');

        // Build scales x-axis and y-axis
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.01);
        var y1Scale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.02);

        // calling scales
        var x1AxisLabel = d3.axisBottom().scale(x1Scale);
        var y1AxisLabel = d3.axisLeft().scale(y1Scale);

        // Build color scales
        var metric1ColorScale = d3.scaleLinear()
            .range(["#00ffff", "#1b3bdc"])
            .domain([d3.min(data, (d) => d.metric1), d3.max(data, (d) => d.metric1)]);

        // Labels of row and columns
        x1Scale.domain(data.map((d) => d.dim1_name));
        y1Scale.domain(data.map((d) => d.metric1).sort(d3.descending));




        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')

            .style('text-anchor', 'end') // Adjust text-anchor to 'end'
            .attr('dx', '-.8em') // Adjust horizontal spacing
            .attr('dy', '-.15em') // Adjust vertical spacing
            .attr('transform', 'rotate(-45)') // Rotate the labels for better visibility
            .attr('font-size', '13px')// You can set font-size here if needed



        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('text-anchor', 'end') // Adjust text-anchor to 'end'
            .attr('dy', '.2em') // Adjust vertical spacing
            .attr('dx', '-.5em') // Adjust horizontal spacing
            .attr('font-size', '13px'); // You can set font-size here if needed


        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + (chart.margin.bottom - 20))
            .text(chart.x1AxisDisplayName);

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .text(chart.y1AxisDisplayName);

        // create a tooltip
        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;');

        // add the squares
        svg.selectAll()
            .data(data, (d) => d.dim1_name + ':' + d.metric1)
            .enter()
            .append('circle')
            .attr('cx', (d) => x1Scale(d.dim1_name) + x1Scale.bandwidth()/2)
            .attr('cy', (d) => y1Scale(d.metric1) + y1Scale.bandwidth()/2)
            .attr('r',10)
            .style('fill', (d) => `rgba(206,20,125, ${d.metric1 / maxMetricValue})`)
            .attr('width', x1Scale.bandwidth())
            .attr('height', y1Scale.bandwidth())
            .style('fill', (d) => metric1ColorScale(d.metric1))
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                console.log("good morning")
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim1_name
                    + '<br>' + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0);
            });


        svg.append("text")
            .attr("x", chart.width / 2.5)
            .attr("y", 0 - (chart.margin.top / 2)+20)
            .attr("text-anchor", "middle")
            .style("font-size", "30px")
            .text(chart.title);
    // });
}
